module.exports = __webpack_public_path__ + "img/Frame-85.54797803.svg";